
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, Home, Phone, Mail } from "lucide-react";
import { toast } from "@/components/ui/use-toast";

interface PartnerDashboardHeaderProps {
  partnerName: string;
  partnerId: string;
  partnerPhone?: string;
  partnerEmail?: string;
}

const PartnerDashboardHeader: React.FC<PartnerDashboardHeaderProps> = ({ 
  partnerName,
  partnerId,
  partnerPhone,
  partnerEmail
}) => {
  const navigate = useNavigate();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // Check if we're in a client context and not admin
    const adminId = localStorage.getItem("adminId");
    setIsClient(!adminId);
  }, []);

  const handleLogout = () => {
    if (isClient) {
      // Clear partner session
      sessionStorage.removeItem("partnerId");
      sessionStorage.removeItem("partnerName");
      
      toast({
        title: "Αποσυνδεθήκατε",
        description: "Έχετε αποσυνδεθεί επιτυχώς.",
      });
      
      // Redirect to login
      navigate("/partner/login");
    } else {
      // If admin is viewing, go back to partners list
      navigate("/admin/partners");
    }
  };

  return (
    <div className="bg-white border-b mb-6 py-4">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <Home className="h-5 w-5 text-primary" />
            <h1 className="text-xl font-semibold">{partnerName}</h1>
          </div>
          
          <div className="flex items-center gap-3">
            {partnerPhone && isClient && (
              <Button variant="outline" size="sm" className="hidden md:flex items-center gap-1">
                <Phone className="h-4 w-4 mr-1" />
                {partnerPhone}
              </Button>
            )}
            
            {partnerEmail && isClient && (
              <Button variant="outline" size="sm" className="hidden md:flex items-center gap-1">
                <Mail className="h-4 w-4 mr-1" />
                {partnerEmail}
              </Button>
            )}
            
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={handleLogout}
              className="flex items-center gap-1"
            >
              <LogOut className="h-4 w-4 mr-1" />
              {isClient ? "Αποσύνδεση" : "Επιστροφή"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerDashboardHeader;
